import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../../auth/authSlice";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const fieldsSlice = createSlice({
  name: "fields",
  initialState,
  reducers: {
    fetchFieldsStart(state) {
      state.isLoading = true;
      state.data = [];
      state.error = null;
    },
    fetchFieldsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchFieldsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { fetchFieldsStart, fetchFieldsSuccess, fetchFieldsFailure } =
  fieldsSlice.actions;
export default fieldsSlice.reducer;
